import axios from "axios";
const CLOUD_URL = "assets/v1/cloud";
const VOIP_URL = "assets/v1/voip";

export function getCloudItemList(headers, page = null) {
  let  url = window.VUE_APP_MISTRA_URL + CLOUD_URL;
  if (page) {
    url += '?page=' + page;
  }

  return axios.get(url, { headers: headers });
}

export function getVoipItemList(headers, page = null) {
  let  url = window.VUE_APP_MISTRA_URL + VOIP_URL;
  if (page) {
    url += '?page=' + page;
  }

  return axios.get(url, { headers: headers });
}
